import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiResponse } from '../models/api.response';
import { CurrentLoggedInUserApi } from '../api.url';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CurrentLoggedInUserService {
  apiUrl = environment.apiBaseUrl
  isChanagePasswordCall: boolean = false;
  userFullName: BehaviorSubject<string>;
  userRoleName: BehaviorSubject<string>;

  constructor(public http: HttpClient) {
    this.userFullName = new BehaviorSubject("");
    this.userRoleName = new BehaviorSubject("");
  }


  set currentUserFullName(value) {
    this.userFullName.next(value);
  }

  get currentUserFullName(): any | Observable<string> {
    return this.userFullName.asObservable();
  }

  set currentUserRoleName(value) {
    this.userRoleName.next(value);
  }

  get currentUserRoleName(): any | Observable<string> {
    return this.userRoleName.asObservable();
  }

  getCurrentLoggedInUserRoleById(userId: string) {
    let params = new HttpParams().set('userId', userId);
    return this.http.get<ApiResponse>(this.apiUrl +CurrentLoggedInUserApi.getCurrentLoggedInUserRoleApiUrl, { params: params });
  }

  getCurrentLoggedInUserRole() {
    return this.http.get<ApiResponse>(this.apiUrl +CurrentLoggedInUserApi.getCurrentLoggedInUserRoleApiUrl);
  }


  getExpireSubscriptionOfLoggedInUser() {
    return this.http.get<ApiResponse>(this.apiUrl +CurrentLoggedInUserApi.getExpireSubscriptionOfLoggedInUserApiUrl);
  }
}
